/**
 * Français (fr) — a partial of `content/en.ts`.
 *
 * Anything omitted renders in English, on purpose. Only the interface strings
 * are translated so far: the marketing copy in the base file is placeholder,
 * and translating placeholder copy is work that has to be thrown away twice.
 */
import type { Translation } from '@/i18n/dictionary'

export const fr: Translation = {
  nav: {
    languageLabel: 'Langue',
    skipToContent: 'Aller au contenu',
    cta: { label: 'Parlons-en' },
  },
  contactBand: {
    heading: 'Prenons contact !',
    cta: { label: 'Parlons-en' },
    photoAlt: 'Cactus colorés encadrés par un ribbon dégradé Digitopia',
  },
  footer: {
    rights: 'Tous droits réservés.',
  },
  preview: {
    badge: 'Aperçu',
    notice: 'Ceci est un aperçu non approuvé de digitopia.ai. Le contenu est provisoire.',
  },
  ui: {
    previous: 'Précédent',
    next: 'Suivant',
  },
}
